/**
 * The rejection CefSharp's JavaScript binding throws when a page calls back
 * into a .NET object it no longer holds. Microsoft's link scanners (Outlook
 * Safe Links, Bing preview) run in a CefSharp headless browser and throw it,
 * as a bare string, on pages they open from an email. Nothing in this app
 * calls `update` on a CefSharp-bound object, so it never comes from our code.
 *
 * Matches the message RUM reports (`Uncaught "…"`) and the raw string.
 */
export const MICROSOFT_LINK_SCANNER_MESSAGE_PATTERN =
  /^(?:Uncaught )?"?Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+"?$/;
